/* Packages */
import React from 'react';
import { render } from 'react-dom';

const productPreviewNodes = Array.from(document.querySelectorAll('[data-product-preview]'));
if (productPreviewNodes.length) {
    import(/* webpackChunkName: "ProductPreview" */ './components/ProductPreview').then(({ default: ProductPreview }) => {
        productPreviewNodes.forEach((node) => render(<ProductPreview {...(JSON.parse(node.dataset.productPreview || '{}'))}/>, node));
    });
}
